module.exports = __webpack_public_path__ + "files/07e3d072e8e2eda9efa4f68b7215362c.svg";